"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUniqueId = void 0;
var react_1 = require("react");
var uuid_1 = require("uuid");
var useUniqueId = function (id) {
    return (0, react_1.useMemo)(function () { return id || (0, uuid_1.v4)(); }, [id]);
};
exports.useUniqueId = useUniqueId;
